import { Navigation, Pagination, Autoplay, EffectFade, Grid } from 'swiper/modules';
import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import 'swiper/css/grid';

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.swiper-container:not(.about-swiper)').forEach((container) => {
        const swiperOptions = JSON.parse(container.getAttribute('data-swiper-options'));

        const swiper = new Swiper(container, {
            ...swiperOptions,
            modules: [Navigation, Pagination, Autoplay, EffectFade, Grid],
        });

        const fractionEl = container.querySelector('.swiper-fraction');
        if (fractionEl) {
            const total = swiper.slides.length;
            const updateFraction = () => fractionEl.textContent = `${swiper.realIndex + 1} / ${total}`;
            updateFraction();
            swiper.on('slideChange', updateFraction);
        }

        const updateZoom = () => {
            container.querySelectorAll('.swiper-slide .slider__item-media').forEach(img => {
                img.classList.remove('active-slide');
            });
            const activeImg = container.querySelector('.swiper-slide-active .slider__item-media');
            if (activeImg) activeImg.classList.add('active-slide');
        };

        swiper.on('slideChange', updateZoom);
        swiper.on('init', updateZoom);
        swiper.emit('init');
    });

    const aboutSwiperContainer = document.querySelector('.about-swiper');
    if (!aboutSwiperContainer) return;

    let aboutSwiperInstance;

    const initAboutSwiper = () => {
        if (window.innerWidth >= 640 && !aboutSwiperInstance) {
            const options = JSON.parse(aboutSwiperContainer.getAttribute('data-swiper-options'));

            aboutSwiperInstance = new Swiper(aboutSwiperContainer, {
                ...options,
                modules: [Navigation, Pagination, Autoplay, EffectFade, Grid],
            });

            const fractionEl = aboutSwiperContainer.querySelector('.swiper-fraction');
            const total = aboutSwiperInstance.slides.length;

            const updateAboutUI = () => {
                if (fractionEl) {
                    fractionEl.textContent = `${aboutSwiperInstance.realIndex + 1} / ${total}`;
                }
                aboutSwiperContainer.querySelectorAll('.slider__item-media').forEach(img => {
                    img.classList.remove('active-slide');
                });
                const activeSlide = aboutSwiperInstance.slides[aboutSwiperInstance.activeIndex];
                if (activeSlide) {
                    const img = activeSlide.querySelector('.slider__item-media');
                    if (img) img.classList.add('active-slide');
                }
            };

            aboutSwiperInstance.on('slideChange', updateAboutUI);
            updateAboutUI();

        } else if (window.innerWidth < 640 && aboutSwiperInstance) {
            aboutSwiperInstance.destroy(true, true);
            aboutSwiperInstance = undefined;

            aboutSwiperContainer.classList.remove('swiper-initialized', 'swiper-horizontal', 'swiper-backface-hidden');
            const wrapper = aboutSwiperContainer.querySelector('.swiper-wrapper');
            if (wrapper) {
                wrapper.style.cssText = 'transform: none; transition: none; width: 100%; display: flex; flex-direction: column; gap: 40px;';
            }

            aboutSwiperContainer.querySelectorAll('.swiper-slide').forEach(slide => {
                slide.style.cssText = 'width: 100%; margin-right: 0;';
            });
        }
    };

    initAboutSwiper();
    window.addEventListener('resize', initAboutSwiper);
});